export default {
  trips: 'الرحلات',
  tripId: 'رقم الطلب',
  pickUp: 'مكان التحميل',
  pickIn: 'مكان التنزيل',
  distance: 'المسافة',
  capacityNumber: 'عدد المتون',
  tripPrice: 'تكلفة الرحلة',
  date: 'تاريخ النقل',
  status: 'الحالة',
  control: 'التحكم',
  withdrawProcess: 'عمليات السحب',
  withdrawDate: 'تاريخ السحب',
  price: 'المبلغ',
  vehicles: 'الشاحنات',
  back: 'رجوع',
  loading: 'جاري التحميل'
}
